<template>
  <div id="defaultId1">
    <div class="pb20">
      <div id="cc5f49" class="udb507">
        <div class="right_cont_box company_box margin-bottom20">
          <div class="flex_box">
            <div>
              <i
                class="iconfont icon-fanhui margin-right40"
                @click="$router.go(-1)"
                style="color: #009ea7"
              ></i>
            </div>
            <div>
              <div class="font24 margin-bottom15 font_bold">
                {{ $route.query.companyName }}
              </div>
              <div class="font18 margin-bottom10 flex_center_start">
                <img class="Countryimg" :src="ImgFlag" alt="" /><span>{{
                  $route.query.countryName
                }}</span>
              </div>
              <div class="font18 margin-bottom15">
                <span class="font666666"> C/O: </span>
                <span class="margin-left10"> {{ $route.query.address }}</span>

                <span class="fontDDDDDD margin-left20">|</span>

                <span
                  class="margin-left20 CountryActive"
                  @click="goToWeb($route.query.website)"
                  >{{ $route.query.website }}</span
                >
              </div>

              <div class="font18">
                <span class="font666666">Transaction Year:</span>
                <span class="margin-left10">
                  {{ $route.query.lastTradeDate }}</span
                >

                <span class="fontDDDDDD margin-left20">|</span>
                <span class="font666666 margin-left20">
                  Total Export Amount:</span
                >
                <span class="margin-left10">
                  {{ $route.query.sumAmount | FilterNum }}</span
                >
                <span class="fontDDDDDD margin-left20">|</span>
                <span class="margin-left20 font666666"
                  >Number of Exports:
                </span>
                <span class="margin-left10">{{
                  $route.query.sumTransactions
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right_cont_box company_box">
          <div class="table-index">
            <h2 class="operations-head-content">
              <span class="operations-headspan">Shipping Overview </span>
            </h2>
            <div class="flex_between_box margin-bottom20">
              <div class="table flex_center_star">
                <div class="left_menu_context">
                  <div class="datePickerBorder flex_between_box">
                    <el-date-picker
                      style="width: 45%"
                      v-model="datePickerOne"
                      prefix-icon="''"
                      class="datePickerOne"
                      value-format="yyyy"
                      type="year"
                      @change="datepcikerChange"
                      placeholder="Start date"
                    >
                    </el-date-picker>
                    <el-date-picker
                      class="datePickerOne"
                      style="width: 50%"
                      v-model="datePickerTwo"
                      type="year"
                      @change="datepcikerChange"
                      value-format="yyyy"
                      placeholder="End date"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="left_menu_context">
                  <el-select
                    :popper-append-to-body="false"
                    filterable
                    v-model="hsCodevalue"
                    clearable
                    class="margin-left20 top_search_select search-select-con"
                    placeholder="Enter  Products"
                    @change="selectChange"
                  >
                    <el-option
                      v-for="item in productList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <el-button
                style="background-color: #009ea7 !important"
                class="btn_export btn_reset"
                @click="ResetTarde()"
              >
                Reset</el-button
              >
            </div>
            <div class="operations-box-bottom table_X">
              <el-table
                :data="ImporttableData"
                style="width: 100%"
                v-loading="loading"
                :key="key"
                empty-text="No Data"
              >
                <el-table-column
                  prop="ie_date"
                  width="180"
                  :label="$t('MyDatabase.Date')"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="table-content">{{ scope.row.ie_date }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="Product Name"
                  label="Product Name"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      @click="goToProduct(scope.row)"
                      class="table-content CountryActive"
                      >{{ scope.row.hscode_description_inter }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="import_country_inter"
                  width="260"
                  :label="$route.query.type == 1 ? 'Destination' : 'Origin'"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      @click="goCountry(scope.row.import_country_code)"
                      class="table-content CountryActive"
                      v-if="$route.query.type == 1"
                      >{{ scope.row.import_country_inter }}</span
                    >
                    <span
                      @click="goCountry(scope.row.export_country_code)"
                      class="table-content CountryActive"
                      v-else
                      >{{ scope.row.export_country_inter }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column prop="Amount" label="Amount" width="200">
                  <template slot-scope="scope">
                    <span class="table-content">{{
                      scope.row.total_count | FilterNum
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Details"
                  label="Details"
                  align="center"
                  width="200"
                >
                  <template slot-scope="scope">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      popper-class="table_popover"
                      content="Waybill Details"
                      text-align="center"
                    >
                      <i
                        slot="reference"
                        @click="gotoExportDetail(scope.row.data_id)"
                        style="color: #009ea7"
                        class="iconfont icon-xiangqing-"
                      ></i>
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
              <div class="page_i_box">
                <Page
                  :totalFont="true"
                  :total="page.total"
                  :pageSize.sync="page.pageSize"
                  :currentPage="page.pageNo"
                  @onPageChange="onPageChangeListTree"
                ></Page>

                <div class="search_rsult_txt line_2">
                  {{ page.pageNo }}-{{ page.pageSize }} of over
                  {{ page.total | FilterNum }} results for "Shipping Overview"
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>

  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import Page from "@/components/page/index.vue";

import rectcard from "@/components/rectCard/index.vue";
import content_text from "@/components/text_content/index.vue";
import gui_card from "@/components/gui_card/gui_card.vue";
import { mixins1 } from "@/mixins/index";

import ReLogin from "@/components/ReLogin.vue";
import { getCompanySnap } from "@/api/companyApi.js";
import { searchTradeHscode, searchFilterConditions } from "@/api/searchApi.js";
//importEnd

export default {
  name: "",
  mixins: [mixins1],
  props: {},

  components: {
    gui_card,
    rectcard,
    content_text,
    Page,
    ReLogin,
  },
  computed: {},
  created() {},
  mounted() {
    let countryImg = this.getCountryImgUrl(this.$route.query.countryCode);
    this.ImgFlag = require("../../../../static" + countryImg);
    this.$emit("UpdatamarkTotalList", false);
    this.getsearchFilterConditions();
    this.getCompanyList();
    this.$store.dispatch("app/toggleMenu", true);
    this.$store.dispatch("app/setTools", {
      name: "saved",
      key: "isActive",
      value: true,
    });
  },
  data() {
    return {
      reLoginVis: false,
      key: 0,
      Related: false,
      isExpanded: false,
      datePickerTwo: "",
      parentTablelist: [],
      imexportsDialog: false,
      companyList: [],
      value: {},
      maxCharacters: 200,
      content: [],
      exportLoding: false,
      loading: true,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      ImporttableData: [],
      countryOfDesvalue: "",
      countryOfOrgList: [],
      countryOfOrgvalue: "",

      hsCodeList: [],
      hsCodevalue: "",
      productList: [],
      countryOfDesList: [],
      countryOfOrgvalue: "",
      productvalue: "",
      supplierNameList: [],
      supplierNamevalue: "",
      datePicker: [],
      datePickerOne: "",
      buyerNameList: [],
      buyerNamevalue: "",
      Improtradio: 0,
      companyBase: {},
      ImgFlag: null,

      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  computed: {},
  methods: {
    goToWeb(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
    goCountry(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeCountry/TradeDetail/" +
          item +
          "/tradeMap/map?id3a=" +
          item +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },
    goToProduct(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeProduct/TradeDetail/" +
          item.hscode +
          "/tradeMap/map?id3a=" +
          item.hscode +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },

    ResetTarde() {
      this.datePickerOne = "";
      this.datePickerTwo = "";
      this.buyerNamevalue = "";
      this.supplierNamevalue = "";
      (this.countryOfDesvalue = ""), (this.countryOfOrgvalue = "");
      this.hsCodevalue = "";
      this.selectChange();
    },
    datepcikerChange() {
      if (this.datePickerOne && this.datePickerTwo) {
        let max = Math.min(
          Number(this.datePickerOne == "" ? 0 : this.datePickerOne),
          Number(this.datePickerTwo == "" ? 0 : this.datePickerTwo),
        );
        let min = Math.max(
          Number(this.datePickerOne == "" ? 0 : this.datePickerOne),
          Number(this.datePickerTwo == "" ? 0 : this.datePickerTwo),
        );
        this.datePickerOne = max == 0 ? "" : max.toString();
        this.datePickerTwo = min == 0 ? "" : min.toString();
      }
      this.getCompanyList();
      this.getsearchFilterConditions();
    },
    selectChange() {
      this.getCompanyList();
      this.getsearchFilterConditions();
    },
    getsearchFilterConditions() {
      searchFilterConditions({
        keyword: this.$route.query.id3a,
        hscode: this.hsCodevalue,
        import_name:
          this.$route.query.type == 1 ? this.$route.query.companyName : "",
        export_name:
          this.$route.query.type == 2 ? this.$route.query.companyName : "",
        import_country_code:
          this.$route.query.type == 1 ? this.countryOfDesvalue : "",
        export_country_code:
          this.$route.query.type == 2 ? this.countryOfOrgvalue : "",
        startTime: this.datePickerOne,
        endTime: this.datePickerTwo,
      }).then((res) => {
        if (res.code == 200) {
          this.buyerNameList = res.data.buyerNameList;
          this.countryOfDesList = res.data.countryOfDesList;
          this.countryOfOrgList = res.data.countryOfOrgList;
          this.hsCodeList = res.data.hsCodeList;
          this.productList = res.data.hsCodeList;
          this.supplierNameList = res.data.supplierNameList;
        }
      });
    },
    getCompanySnapDetail(value) {
      if (this.$route.query.type == 1) {
        value = value.export_aaaid;
      } else {
        value = value.import_aaaid;
      }
      getCompanySnap({
        id3a: value,
      }).then((res) => {
        this.companyBase = res.data;
      });
    },

    gotoExportDetail(Details) {
      this.$router.push({
        path: "importDetailCompany",
        query: {
          Moudles: this.$route.query.Moudles,
          idpower: this.$route.query.idpower,
          id3a: this.$route.query.id3a,
          SACode1: this.$route.query.SACode1,
          DetailsiD: Details,
        },
      });
    },
    onPageChangeListTree({ page, size }) {
      this.page.pageNo = page;
      this.page.size = size;
      this.getCompanyList();
    },

    getCompanyList() {
      this.loading = true;
      searchTradeHscode({
        hscode: this.hsCodevalue,
        keyword: this.$route.query.id3a,
        import_name:
          this.$route.query.type == 1 ? this.$route.query.companyName : "",
        export_name:
          this.$route.query.type == 2 ? this.$route.query.companyName : "",
        import_country_code:
          this.$route.query.type == 1
            ? this.$route.query.countryOfDesvalue
            : "",
        export_country_code:
          this.$route.query.type == 2 ? this.countryOfOrgvalue : "",
        startTime: this.datePickerOne,
        endTime: this.datePickerTwo,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.ImporttableData = res.data.rows;
          this.page.total = res.data.total;
        } else {
          this.ImporttableData = [];
          this.page.total = 0;
        }
      });
    },

    scrollToTop() {
      this.Related = true;
    },

    // 获取数据

    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #238acc;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.uc1096 {
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.computer_right_cont_box {
  margin-top: 1.4285714285714286rem;
}

.tablewieth {
  width: 70%;
}

.table_box {
  position: relative;
}

.echarts-content {
  margin-top: 2.857142857142857rem;
  padding: 0 4.285714285714286rem;
}

.echarts-item {
  display: flex;
  justify-content: flex-start;
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  margin-bottom: 2.142857142857143rem;
}

.echarts-item-left {
  display: inline-block;
  width: 15.714285714285714rem;
  margin-right: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.ecahrtstutwo {
  position: relative;
  left: 1.4285714285714286rem;
}

.uUIRzUi {
  padding: 2.142857142857143rem 2.857142857142857rem;
}

.left_box {
  width: 91%;
}

.right_box {
  width: 40%;
  background-color: #fff;
}

.operations-box-bottom /deep/ .el-table .cell {
  color: #1a2332;
  line-height: 30px;
}
.operations-box-bottom /deep/ .el-table th:first-child > .cell,
.operations-box-bottom /deep/ .el-table tr td:first-child > .cell {
  padding-left: 30px;
}
.operations-box-bottom /deep/ .el-table th:nth-child(5) > .cell,
.operations-box-bottom /deep/ .el-table tr td:nth-child(5) > .cell {
  padding-right: 30px;
}

.companyimg {
  float: left;
  width: 36px;
  height: 26px;
  flex: none;
  margin-right: 4px;
  box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 20%);
}

.left_menu {
  background-color: #fff;
  max-height: 95%;
  overflow-y: auto;
  height: auto;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.udb507 {
  width: 100%;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  padding-left: 0em;
}

.udb507two {
  width: 100% !important;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 10px;
}

.SactionIcon {
  position: relative;
  top: 0.3rem;
  left: 1rem;
}

.datePickerOne /deep/.el-input__inner {
  border: none !important;
}

.datePickerOne /deep/ .el-input__prefix {
  left: -22px !important;
  color: #1a2332 !important;
}

.datePickerBorder {
  border-radius: 10px;
  border: 1px solid #cccccc;
}
.datePickerBorder,
.left_menu_context .top_search_select {
  width: 400px;
  height: 36px;
}
.left_menu_context >>> .el-input__inner,
.datePickerBorder >>> .el-input__inner {
  font-size: 16px;
  line-height: 34px;
}
.datePickerBorder >>> .el-input__inner {
  text-align: center;
  padding: 0;
}
.left_menu_context .top_search_select /deep/ .el-select-dropdown {
  max-width: 800px;
}

.products-Shipping-table {
  width: 13.5714rem;
  background: #f2f5f9;
  font-family: "Arial Bold";
  height: 3.57142857rem;
  line-height: 3.57142857rem;
  display: inline-block;
}

.products-Shipping-table-text {
  padding-left: 1.4285714rem;
  width: 13.5714rem;
}

.products-Shipping-item {
  font-size: 18px;
  color: #1a2332;
  width: 48%;
  border-bottom: 1px solid #cccccc;
}

.Countryimg {
  width: 36px;
  margin-right: 5px;
}
.icon-fanhui {
  font-size: 24px;
}
.btn_reset {
  border-radius: 5px;
  font-size: 16px;
  min-width: 120px;
  padding: 10px 20px;
}
/* @media (max-width: 1680px) {
  .datePickerBorder,
  .left_menu_context .top_search_select {
    width: 350px;
  }
} */
@media (max-width: 1920px) {
  .icon-fanhui {
    font-size: 20px;
  }
  .datePickerBorder {
    border-radius: 10px;
  }
  .datePickerBorder,
  .left_menu_context .top_search_select {
    width: 300px;
    height: 32px;
  }
  .left_menu_context >>> .el-input__inner,
  .datePickerBorder >>> .el-input__inner {
    font-size: 14px;
    line-height: 30px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 22px;
  }
  .Countryimg {
    width: 28px;
    margin-right: 4px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
  .operations-box-bottom /deep/ .el-table th:first-child > .cell,
  .operations-box-bottom /deep/ .el-table tr td:first-child > .cell {
    padding-left: 22px;
  }
  .operations-box-bottom /deep/ .el-table th:nth-child(5) > .cell,
  .operations-box-bottom /deep/ .el-table tr td:nth-child(5) > .cell {
    padding-right: 22px;
  }
  .operations-box-bottom /deep/ .el-table__header col:first-child,
  .operations-box-bottom /deep/ .el-table__body col:first-child,
  .operations-box-bottom /deep/ .el-table__header col:nth-child(4),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(4),
  .operations-box-bottom /deep/ .el-table__header col:nth-child(5),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(5) {
    width: 150px;
  }
  .operations-box-bottom /deep/ .el-table__header col:nth-child(3),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(3) {
    width: 195px;
  }
  .btn_reset {
    font-size: 14px;
    min-width: 90px;
    padding: 9px 20px;
  }
}
@media screen and (max-width: 1439px) {
  .right_box {
    padding: 20px 26px 13px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }
  .icon-fanhui {
    font-size: 18px;
  }
  .datePickerBorder {
    border-radius: 5px;
  }
  .datePickerBorder,
  .left_menu_context .top_search_select {
    width: 267px;
    height: 30px;
  }
  .left_menu_context >>> .el-input__inner,
  .datePickerBorder >>> .el-input__inner {
    line-height: 28px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 20px;
  }
  .Countryimg {
    width: 24px;
    margin-right: 3px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .operations-box-bottom /deep/ .el-table th:first-child > .cell,
  .operations-box-bottom /deep/ .el-table tr td:first-child > .cell {
    padding-left: 20px;
  }
  .operations-box-bottom /deep/ .el-table th:nth-child(5) > .cell,
  .operations-box-bottom /deep/ .el-table tr td:nth-child(5) > .cell {
    padding-right: 20px;
  }
  .operations-box-bottom /deep/ .el-table__header col:first-child,
  .operations-box-bottom /deep/ .el-table__body col:first-child,
  .operations-box-bottom /deep/ .el-table__header col:nth-child(4),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(4),
  .operations-box-bottom /deep/ .el-table__header col:nth-child(5),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(5) {
    width: 135px;
  }
  .operations-box-bottom /deep/ .el-table__header col:nth-child(3),
  .operations-box-bottom /deep/ .el-table__body col:nth-child(3) {
    width: 175px;
  }
}
</style>
